import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  tone?: 'coral' | 'cream';
}
export function CtaButton({
  children,
  href = '#oferta',
  size = 'lg',
  tone = 'coral'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'w-full max-w-md px-6 py-4 text-[13px] sm:w-auto sm:max-w-none sm:px-12 sm:py-5 sm:text-base' : 'w-full max-w-sm px-6 py-4 text-xs sm:w-auto sm:max-w-none sm:px-7 sm:text-sm';
  const tones = tone === 'coral' ? 'bg-coral text-cream hover:bg-coral-dark shadow-cta' : 'bg-cream text-ink hover:bg-white shadow-soft';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 rounded-full sm:gap-3 font-semibold uppercase tracking-[0.12em] transition-[transform,background-color] duration-150 ease-out-expo hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink ${sizing} ${tones}`} data-id="element-58" data-mp="109twi2nt4hkj">
      <span className="text-center leading-tight" data-id="element-59" data-mp="35xxt0rx2krtt">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-60" data-mp="39yrg5j2ou2ln" />
    </a>;
}